<template>
  <div id="page-product-documents-standard-clause-form">
    <vs-row >
      <vs-col>
        <vs-row>
          <vs-col>
            <h2 class="mb-1">{{ pageTitle }}</h2>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col>
            <card-page>
              <vue-element-loading :active="busy"></vue-element-loading>
              <div class="flex justify-between">
                <div class="md:w-1/2 w-full">
                  <h3 v-if="isEdit" class="m-4">Edit document</h3>
                  <vue-form-generator
                      :schema="schema"
                      :model="model"
                      :options="formOptions"
                      ref="form"
                  />
                </div>
                <div v-if="isEdit" class="md:w-1/2 w-full">
                  <h3 class="m-4">Upload New File</h3>
                  <document-upload-form
                      :model="model"
                      ref="additional"
                  />
                </div>
              </div>
              <div class="w-full" v-if="isEdit">
                <document-grid
                    :apiModel="apiModel"
                    :model="model"
                />
              </div>
          </card-page>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import DocumentGrid from "@/views/pages/product-documents/DocumentGrid";
import DocumentUploadForm from "@/views/pages/product-documents/DocumentUploadForm";
import ProductDocumentUploadFormMixin from "@/components/mixins/ProductDocumentUploadFormMixin";
import FormModelMixin from "@/components/mixins/FormModelMixin";
import {validateFileType} from "../../../../validation/Vfg/resources";
import CardPage from '../../../components/Views/CardPage';

export default {
  name: "StandardClauseForm",
  components: {
    DocumentGrid,
    DocumentUploadForm,
    CardPage
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    forms: {
      type: Array,
      default: () => [
        'form',
      ]
    }
  },
  mixins: [FormModelMixin, ProductDocumentUploadFormMixin],
  data() {
    return {
      model: {
        StandardClause: '',
        IsEnabled: 0,
        File: null,
        FriendlyName: null,
      },
      schema: {
        groups: [
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "input",
                inputType: "text",
                styleClasses: "md:w-1/2 w-full",
                label: "Friendly Name",
                model: "FriendlyName",

                required: true,

                validator: () => {
                  if (this.model.FriendlyName && this.model.FriendlyName.length > 0) {
                    return true;
                  }

                  return 'This field is required';
                },
                visible: () => !this.model.id,
              },
            ],
          },
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "upload",
                inputType: "file",
                styleClasses: "w-full",
                label: "File",
                model: "File",
                placeholder: "",
                required: true,
                validator: [() => {
                  if (this.model.hasOwnProperty("File") && this.model.File) {
                    return true;
                  }

                  return 'This field is required';
                }, validateFileType(['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'xls', 'xlsm'])],
                files: true,
                onChanged: (model, schema, event, instance) => {
                  this.model.File = instance.$el.children[0].files[0];
                },
                visible: () => !this.model.id,
              },

            ],
          },
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "input",
                inputType: "text",
                styleClasses: "md:w-4/5 w-full",
                label: "Standard Clause",
                model: "StandardClause",

                validator: 'string',
                required: true,
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      formReferences: this.forms,
    };
  },
  computed: {
    pageTitle() {
      if (!this.model) {
        return '';
      }

      let mode = 'Create a Standard Clause';

      if (this.model.hasOwnProperty("id") && this.model.id > 0) {
        mode = `Standard Clause #${this.model.id}`
      }

      return mode;
    },
    isEdit() {
      return (this.model.hasOwnProperty("id") && this.model.id > 0);
    },
  },
};
</script>

<style scoped>

</style>
